import Message from '@web-common/components/UI/Message/SiriusMessage';
import { createAsyncThunk } from '@reduxjs/toolkit';
const getDefaultThunkRejected = (thunkName) => (_, action) => {
    const error = (action === null || action === void 0 ? void 0 : action.error) || action.payload;
    console.error(`${thunkName} thunkError`, error);
};
export function thunkHelperFactory(reducerName, thunks, extraReducerList) {
    return params => {
        const { name, request, fulfilled, pending, rejected = getDefaultThunkRejected(name) } = params;
        if (thunks[name]) {
            console.warn(`重复的Thunk： ${name}`);
            return;
        }
        thunks[name] = createAsyncThunk(`${reducerName}/${name}`, request);
        extraReducerList.push(builder => {
            fulfilled && builder.addCase(thunks[name].fulfilled, fulfilled);
            pending && builder.addCase(thunks[name].pending, pending);
            rejected && builder.addCase(thunks[name].rejected, rejected);
        });
    };
}
export const reduxMessage = {
    warn: (params) => {
        setTimeout(() => {
            Message.warn(params);
        }, 0);
    },
    loading: (params) => {
        setTimeout(() => {
            Message.loading(params);
        }, 0);
    },
    error: (params) => {
        setTimeout(() => {
            Message.error(params);
        }, 0);
    },
    info: (params) => {
        setTimeout(() => {
            Message.info(params);
        }, 0);
    },
    success: (params) => {
        setTimeout(() => {
            Message.success(params);
        }, 0);
    },
};
